<template>
  <div>
    <h1>{{ $t("travelService.chooseOfferForm.title") }}</h1>
    <fieldset :key="item.id" v-for="(item, itemIndex) of allOffer.items" class="custom-fieldset">
      <legend>
        {{ $t("travelService.chooseOfferForm.service") }} {{ itemIndex + 1 }} -
        {{ $t("travelService.types." + item.type) }}
      </legend>
      <v-row>
        <v-col md="10" v-if="item.selectedOffer.html != null && item.selectedOffer.html.length !== 0">
          <w-y-s-i-w-y-g-html-element :html="item.selectedOffer.html" />
        </v-col>
        <v-col md="10" v-if="item.type === 'hotel' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <hotel-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'car' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <car-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'flight' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <flight-response-presentation :offer="item.selectedOffer" />
        </v-col>
        <v-col md="10" v-if="item.type === 'rail' && (item.selectedOffer.html == null || item.selectedOffer.html.length === 0)" cols="12">
          <rail-response-presentation :offer="item.selectedOffer" />
        </v-col>

        <v-col class="pl-3" md="2" cols="12">
          <v-text-field :label="$t('global.amount')" :value="item.selectedOffer.price + ' ' + item.selectedOffer.currency" outlined readonly> </v-text-field>
          <v-text-field
            :label="$t('travelService.chooseOfferForm.costCentreFullName')"
            outlined
            readonly
            v-if="$store.state.Auth.userProperties.system_settings.cost_centre_on_delegations !== settingTypes.NOT_AVAILABLE"
            v-model="item.cost_centre"
          >
          </v-text-field>

          <div class="text-center my-3" style="width: 100%">
            <v-icon color="primary" style="font-size: 100px">{{ bookingIconType(item.type) }}</v-icon>
          </div>
        </v-col>

        <v-col cols="12">
          <ClientViewOfferHistory :offers="[item.selectedOffer]" />
        </v-col>
      </v-row>
      <travel-users-inline-form
        :available-users="availableUsers"
        :readonly="true"
        :required-props="getRequiredProps(item)"
        :users="item.users"
        @saved="downloadAvailableUsers()"
      />
      <v-col cols="12">
        <v-alert color="error darken-4" outlined>
          {{ $t("travelService.chooseOfferForm.checkData.firstPart") }}
          <span class="font-weight-bold">{{ $t("travelService.chooseOfferForm.checkData.boldPart") }}</span>
        </v-alert>
      </v-col>
    </fieldset>

    <v-alert color="grey darken-2" class="text-justify" outlined>
      {{ $t("travelService.separatePart") }} <a href="#" @click.prevent="SeparateTravelService($route.params.id)">{{ $t("travelService.separateLink") }}</a
      >.
    </v-alert>

    <h3 v-if="!$store.getters['Ajax/loading']">
      {{ $t("global.sum") }}:
      <template v-for="cost in summaryDataTableCost"> {{ cost.value }} {{ cost.currency }} </template>
      <template v-if="summaryDataTableCost.length === 0"> 0. {{ $t("travelService.noServicesSelectedToOrder") }} </template>
    </h3>

    <!--        <v-card>-->
    <v-card-actions>
      <v-spacer />
      <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
      <v-btn :disabled="$store.getters['Ajax/loading']" @click.native="reject()" class="error" text>{{ $t("global.reject") }}</v-btn>
      <v-btn :disabled="$store.getters['Ajax/loading']" @click.native="accept()" class="success" text>{{ $t("global.accept") }}</v-btn>
    </v-card-actions>
    <!--        </v-card>-->
  </div>
</template>

<script>
import { settingTypes } from "../../staticData/SettingsTypes";
import HotelResponsePresentation from "../../components/TravelService/OfferPresentation/HotelResponsePresentation";
import CarResponsePresentation from "../../components/TravelService/OfferPresentation/CarResponsePresentation";
import FlightResponsePresentation from "../../components/TravelService/OfferPresentation/FlightResponsePresentation";
import RailResponsePresentation from "../../components/TravelService/OfferPresentation/RailResponsePresentation";
import TravelUsersInlineForm from "../../components/TravelService/TravelUsersInlineForm";
import WYSIWYGHtmlElement from "../../components/Shared/WYSIWYGHtmlElement";
import ClientViewOfferHistory from "../../components/TravelService/ClientViewOfferHistory";
import { bookingIconType } from "../../staticData/ServiceOrder";
import SeparateTravelService from "../../repository/SeparateTravelService";

export default {
  name: "TravelServiceApprovalView",
  components: {
    ClientViewOfferHistory,
    WYSIWYGHtmlElement,
    TravelUsersInlineForm,
    RailResponsePresentation,
    FlightResponsePresentation,
    CarResponsePresentation,
    HotelResponsePresentation
  },
  data: () => ({
    allOffer: {
      items: []
    },
    availableUsers: [],
    settingTypes
  }),
  created() {
    this.axios
      .get("/travel-service/get-offer-to-approval", {
        params: { id: this.$route.params.id }
      })
      .then(resp => {
        if (typeof resp.data.status != "undefined" && resp.data.status === "ALREADY_DECIDED") {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("travelService.alreadyDecided"),
            color: "info",
            position: "down"
          });
          this.$router.push("/travel-service");
        }
        this.allOffer = resp.data;
      });
    this.downloadAvailableUsers();
  },
  computed: {
    summaryDataTableCost() {
      let result = [];
      if (this.allOffer == null) return result;
      for (let offerItem of this.allOffer.items) {
        if (offerItem.selectedOffer != null) {
          let oldCurrencyRow = result.find(v => v.currency === offerItem.selectedOffer.currency);
          if (typeof oldCurrencyRow != "undefined") {
            oldCurrencyRow.value += offerItem.selectedOffer.price;
          } else {
            result.push({
              currency: offerItem.selectedOffer.currency,
              value: offerItem.selectedOffer.price
            });
          }
        }
      }
      return result;
    },
    userList() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ text: user.name + " " + user.surname, value: user.id });
      }
      return result;
    }
  },
  methods: {
    SeparateTravelService,
    downloadAvailableUsers() {
      this.axios.get("/travel-service/get-available-users").then(resp => {
        this.availableUsers = resp.data;
      });
    },
    bookingIconType,
    accept() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("travelService.approvalDialogConfirm.content"),
        title: this.$t("travelService.approvalDialogConfirm.title")
      });
      result.then(() => {
        this.axios.post("travel-service/offer-accept", { id: this.allOffer.id }).then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.$router.push("/travel-service");
        });
      });
    },
    reject() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("travelService.rejectedDialogConfirm.content"),
        title: this.$t("travelService.rejectedDialogConfirm.title")
      });
      result.then(() => {
        this.axios.post("travel-service/offer-reject", { id: this.allOffer.id }).then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.$router.push("/travel-service");
        });
      });
    },
    cancel() {
      this.$router.push("/travel-service");
    },
    getRequiredProps(orderItem) {
      return {
        is_birth_date_required: orderItem.selectedOffer.is_birth_date_required,
        is_document_number_required: orderItem.selectedOffer.is_document_number_required,
        is_document_expire_required: orderItem.selectedOffer.is_document_expire_required,
        is_email_required: orderItem.selectedOffer.is_email_required,
        is_phone_required: orderItem.selectedOffer.is_phone_required
      };
    }
  }
};
</script>

<style scoped />
